import React from 'react';

import Portal from '../../general/components/Portal';

import BrowseLayerOuter from './BrowseLayerOuter';

const Content = props => (
    <div className="row">
        <BrowseLayerOuter {...props} />
    </div>
);

const ContentArea = ({Content, fluid, ...props}) => (
    <Portal container="content-area">
        <div className={fluid ? 'container-fluid' : 'container'}>
            <Content {...props} />
        </div>
    </Portal>
);

ContentArea.defaultProps = {
    fluid: true,
    Content,
};

export default ContentArea;
